import axios from 'axios'

export const emailSubscriptionApi = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  subscribe(_email: string): Promise<{ readonly success: boolean }> {
    return axios.get('http://localhost:3001/subscribe').then(({ data }) => data)
  },
}
